// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"92a0fbf5","477":"7cc806b9"}[chunkId] + ".chunk.js";
};